import { FormattedMessage } from '@b-stock/fe-core/bstock-react'

import { DetailsValue } from '@/buyer-portal/components/features/shared'
import { HeaderAlignedPageWidth } from '@/components/PageWidth'
import type { CmsSellerProfile } from '@/helpers/api/fetchPayload'

import FaqDetails, { getFaqsForCostco, type FaqSection } from './cstFaqDetails'
import { buildCmsFaqSections, hasCmsFaqBody } from './faqCmsHelpers'
import { Container, InfoSection, StorefrontTableContainer, Title } from './ui'

/** Hand-built FAQ bodies by storefront slug; a slug with no entry falls through to the CMS. */
const LEGACY_FAQ_BY_SLUG: Record<
  string,
  (storefrontName: string, myAccountHpNav: boolean) => FaqSection[]
> = {
  costco: getFaqsForCostco,
}

type FaqContentProps = {
  cmsSellerProfile?: CmsSellerProfile | null
  /** True when ENABLE_ABOUT_FAQ_BY_STOREFRONT_ID includes this storefront for FAQ. */
  legacyCostcoStyleFaqEnabled: boolean
  /** True when MY_ACCOUNT_HP_NAV is on — points settings links at home-portal. */
  myAccountHpNav: boolean
  sellerSlug: string
  storefrontName: string
}

export default function FaqContent({
  cmsSellerProfile,
  legacyCostcoStyleFaqEnabled,
  myAccountHpNav,
  sellerSlug,
  storefrontName,
}: FaqContentProps) {
  const cms = cmsSellerProfile
  const cmsSections = cms && hasCmsFaqBody(cms) ? buildCmsFaqSections(cms) : []
  const legacyFaqs = legacyCostcoStyleFaqEnabled
    ? LEGACY_FAQ_BY_SLUG[sellerSlug.toLowerCase()]
    : undefined

  const sections: FaqSection[] | null = legacyFaqs
    ? legacyFaqs(storefrontName, myAccountHpNav)
    : cmsSections.length > 0
      ? cmsSections
      : null

  return (
    <HeaderAlignedPageWidth>
      <StorefrontTableContainer>
        <Title>
          <FormattedMessage id="Storefront.faq.title" />
        </Title>
        <InfoSection>
          <DetailsValue>
            {sections ? (
              <FaqDetails sections={sections} />
            ) : (
              <Container>
                <p>
                  <FormattedMessage id="Storefront.faq.emptyCms" />
                </p>
              </Container>
            )}
          </DetailsValue>
        </InfoSection>
      </StorefrontTableContainer>
    </HeaderAlignedPageWidth>
  )
}
